import { render } from "./UIGuide.vue?vue&type=template&id=0cd0341a&scoped=true"
const script = {}

import "./UIGuide.vue?vue&type=style&index=0&id=0cd0341a&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd0341a"]])

export default __exports__